import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22d2b3b3")

_pushScopeId("data-v-22d2b3b3")
const _hoisted_1 = { class: "container col align-center" }
const _hoisted_2 = { class: "w-full flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建项目")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-loading" }, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查看卡牌 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_image_uploader = _resolveComponent("image-uploader")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_card_keyword_create_dialog = _resolveComponent("card-keyword-create-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_button, {
          class: "font-20",
          icon: "el-icon-circle-plus-outline",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createDialogVisible = true))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData.content,
        class: "w-full",
        height: "100%",
        onCellClick: _ctx.cellClick
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "项目",
            prop: "keyword",
            width: "80"
          }, {
            default: _withId(({row}) => [
              _createVNode(_component_el_tag, null, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(row.keyword), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            width: "140"
          }, {
            default: _withId(({row}) => [
              (row.progressStatus ===  'FETCHING_IMAGES')
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createTextVNode("原图爬取中(已爬取:" + _toDisplayString(row.loadedPage) + "页)", 1),
                    _hoisted_6
                  ]))
                : _createCommentVNode("", true),
              (row.progressStatus ===  'FETCH_IMAGES_DONE')
                ? (_openBlock(), _createBlock("div", _hoisted_7, "原图爬取完毕"))
                : _createCommentVNode("", true),
              (row.progressStatus ===  'UPLOADING')
                ? (_openBlock(), _createBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "初选" }, {
            default: _withId(({row}) => [
              (row.progressStatus !==  'UPLOADING')
                ? (_openBlock(), _createBlock(_component_el_progress, {
                    key: 0,
                    percentage: Math.round(100 * row.preSelectedPageCount/row.loadedPage),
                    status: "warning",
                    type: "circle"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(row.preSelectedPageCount) + "/" + _toDisplayString(row.loadedPage) + "页, ", 1),
                      _hoisted_9,
                      _createTextVNode("已选" + _toDisplayString(row.selectedCount) + "张 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["percentage"]))
                : (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode(_component_image_uploader, {
                      multiple: true,
                      onSuccess: _ctx.handleImageUploaded,
                      onBeforeUpload: ($event: any) => (_ctx.currentUploadKeywordId=row.id)
                    }, null, 8, ["onSuccess", "onBeforeUpload"])
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "切图" }, {
            default: _withId(({row}) => [
              (row.progressStatus !==  'UPLOADING')
                ? (_openBlock(), _createBlock(_component_el_progress, {
                    key: 0,
                    percentage: Math.round(100 * row.cropedCount/row.selectedCount),
                    type: "circle"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(row.cropedCount) + "/" + _toDisplayString(row.selectedCount) + "张, ", 1),
                      _hoisted_11,
                      _createTextVNode("已切" + _toDisplayString(row.cardCount) + "张卡片 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["percentage"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "190"
          }, {
            default: _withId(({row}) => [
              _createVNode("div", _hoisted_12, [
                (row.cardCount > 0 || row.progressStatus ===  'UPLOADING')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "margin-right-5",
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.gotoCardList(row))
                    }, {
                      default: _withId(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_popconfirm, {
                  title: "确定删除吗？",
                  onConfirm: ($event: any) => (_ctx.deleteKeyword(row))
                }, {
                  reference: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withId(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onCellClick"]),
      _hoisted_15,
      _createVNode(_component_el_pagination, {
        "current-page": _ctx.tableData.pageNumber,
        "page-count": _ctx.tableData.totalPages,
        total: _ctx.tableData.totalCount,
        background: "",
        class: "margin-top-10",
        layout: "total, prev, pager, next, jumper",
        onCurrentChange: _ctx.reloadPage,
        onPrevClick: _ctx.reloadPage,
        onNextClick: _ctx.reloadPage
      }, null, 8, ["current-page", "page-count", "total", "onCurrentChange", "onPrevClick", "onNextClick"])
    ]),
    _createVNode(_component_card_keyword_create_dialog, {
      modelValue: _ctx.createDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.createDialogVisible = $event)),
      onSuccess: _ctx.keywordCreated
    }, null, 8, ["modelValue", "onSuccess"])
  ], 64))
})